import Vue from 'vue'
import App from './App.vue'
import router from './router'
import firebase from "firebase"

import Team from './models/Team.js'
import config from './config'


const Const = {
  /** Calendar API のパラメタエラーを示す */
  CALENDER_ERROR_INVALID_PARAMS: 1,

  /** Calendar API の原因不明エラーを示す */
  CALENDAR_ERROR_UNKNOWN: 9,
}

/**
 * ログイン処理
 * 
 * @param {function} successFunction 
 * @param {*} errorFunction 
 */
function login(successFunction, errorFunction) {
  firebase.auth().getRedirectResult().then(function (result) {
    if (result.credential) {
      // This gives you a Google Access Token. You can use it to access the Google API.
      // var token = result.credential.accessToken;
      // ...
      console.info('login successed.');
      successFunction(result.user.uid);
    }
    else {
      var provider = new firebase.auth.GoogleAuthProvider();
      provider.addScope('https://www.googleapis.com/auth/contacts.readonly');
      firebase.auth().signInWithRedirect(provider);

      firebase.auth().getRedirectResult().then(function (result) {
        if (result.credential) {
          // This gives you a Google Access Token. You can use it to access the Google API.
          // var token = result.credential.accessToken;
          // ...
        }
        // The signed-in user info.
        // var user = result.user;
      }).catch(function (error) {
        console.info("error from google login. [code:" + error.code + "][message:" + error.message + "]");
        errorFunction();
      });
    }
  }).catch(function (error) {
    console.info("error from google login. [code:" + error.code + "][message:" + error.message + "]");
    errorFunction();
  });
}

function getUserId() {
  if (firebase.auth().currentUser) {
    return firebase.auth().currentUser.email.split('@')[0];
  }
  else {
    console.warn('can not get userId. didn\'t login.');
  }
}


/**
 * 
 */
firebase.initializeApp(config);

if (! firebase.auth().currentUser) {
  login(function(uid) {
    let userId = getUserId()
    console.info(`success login. userId = ${userId}, uid = ${uid}`);
    Vue.prototype.$ownerId = userId

    Team.findByOwnerId(userId).then((team) => {
      // チーム設定画面
      if (!team || !team.name || !team.teamKey) {
        router.push({
          name: 'team',
          params: {
            ownerId: userId
          }
        })
      }
      // カレンダー設定画面
      else if(!team.calendarId || !team.apiKey) {
        router.push({
          name: 'cal',
          params: {
            ownerId: userId
          }
        })

      }
      // console表示
      else {
        router.push({
          name: 'console',
          params: {
            ownerId: userId
          }
        })
      }
    })
  },
  function() {
    console.info('failed login.');
  });
}



Vue.config.productionTip = false

new Vue({
  Const,
  router,
  render: h => h(App)
}).$mount('#app')


